import { createContext } from 'react';

export type SharedProgressBarProps = {
  id: string;
  density: 'default' | 'condensed';
};

/** Context provider for `ProgressBarProps` props meant to be provided to all its progressbar-related child nodes. */
export const SharedProgressBarPropsContext =
  createContext<SharedProgressBarProps>({
    id: '',
    density: 'default',
  });
